import { SearchLight } from '@components/icons'

import GooglePlacesAutocomplete from 'react-google-places-autocomplete'

import { SuggestionType } from '../types'

interface SearchInputProps {
  className?: string
  onSelect: (selection: SuggestionType) => void
  componentRestrictions?: { country: string | string[] }
}

const SearchInput = ({ onSelect, componentRestrictions }: SearchInputProps) => {
  return (
    <div className="w-full relative z-20">
      <div className="w-full relative font-body text-14">
        {/* @ts-ignore */}
        <GooglePlacesAutocomplete
          onSelect={onSelect}
          inputClassName={`border-gray-400 border bg-white pt-4 pb-4 leading-normal pl-4 pr-4 md:pr-6 md:pl-6 md:text-14 md:leading-1.2 font-body w-full`}
          suggestionsClassNames={{
            container:
              'absolute top-0 mt-15 md:mt-12.5 left-0 right-0 w-full bg-white pt-2 pb-2 border border-gray-400',
            suggestion:
              'cursor-pointer font-body text-14 text-black leading-normal pr-2 pl-2 pt-2 pb-2 hover:bg-gray-100',
            suggestionActive: 'text-red',
          }}
          loader={<div>Loading...</div>}
          autocompletionRequest={{
            componentRestrictions,
          }}
          placeholder="Enter your suburb or address"
        />
        <div className="w-6 h-full flex items-center justify-center absolute top-0 right-0 mr-5">
          <SearchLight />
        </div>
      </div>
    </div>
  )
}

export default SearchInput
